import { render } from "./PurchaseStocksMac.vue?vue&type=template&id=39b6f633&scoped=true&ts=true&lang=pug"
import script from "./PurchaseStocksMac.vue?vue&type=script&lang=ts"
export * from "./PurchaseStocksMac.vue?vue&type=script&lang=ts"

import "./PurchaseStocksMac.vue?vue&type=style&index=0&id=39b6f633&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b6f633"]])

export default __exports__